import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
	SOFTWARE_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types';
import messages from './messages';

// rebrand
export const COMPANY_MANAGED_TRANSLATIONS = {
	[CORE_PROJECT]: messages.companyManagedBusiness,
	[SOFTWARE_PROJECT]: messages.companyManagedSoftware,
	[SERVICE_DESK_PROJECT]: messages.companyManagedServiceProject,
	[CUSTOMER_SERVICE_PROJECT]: messages.companyManagedServiceProject,
	[PRODUCT_DISCOVERY_PROJECT]: messages.productDiscovery,
} as const;

export const TEAM_MANAGED_TRANSLATIONS = {
	[CORE_PROJECT]: messages.business,
	[SOFTWARE_PROJECT]: messages.teamManagedSoftware,
	[SERVICE_DESK_PROJECT]: messages.teamManagedServiceProject,
	[CUSTOMER_SERVICE_PROJECT]: messages.teamManagedServiceProject,
	[PRODUCT_DISCOVERY_PROJECT]: messages.productDiscovery,
} as const;
